export default __webpack_public_path__ + "static/media/PRISMA.0bf71788.jpg";